<template>
	<div>
		<!-- Card with record fields -->
		<v-card class="mb-4" theme="dark" style="background-color: #958fc520">
			<v-card-title>{{ adminModule.name.slice(0, -1) }} #{{ record.id }}</v-card-title>

			<v-divider></v-divider>
			<v-card-text class="pa-0">
				<v-list class="w-100 py-0" bg-color="transparent">
					<template v-for="(value, key) in record" :key="key">
						<v-list-item class="py-4">
							<strong class="mr-2">{{ key }}:</strong>
							<span v-if="key.includes('_at')" class="white-p">
								{{ formatDate(value) }}
							</span>
							<span v-else class="white-p">{{ value }}</span>
						</v-list-item>
						<v-divider></v-divider>
					</template>
				</v-list>
			</v-card-text>

			<!-- If user can edit or delete -->
			<v-card-actions class="d-flex align-center justify-end">
				<v-btn v-if="canAction('update')" :href="editLink" variant="text" class="mr-3 normal-spacing">
					Edit Record
				</v-btn>

				<v-btn
					v-if="canAction('delete')"
					color="error"
					variant="text"
					class="normal-spacing"
					@click="deleteRecord">
					Delete
				</v-btn>
			</v-card-actions>
		</v-card>

		<!-- Card with possible relations -->
		<v-card theme="dark" style="background-color: #958fc520">
			<v-card-title>Related Data</v-card-title>
			<v-divider></v-divider>
			<v-card-text class="pa-0">
				<div v-if="possibleRelations.length === 0" class="text-medium-emphasis pa-4">
					No sub-relations found.
				</div>
				<div
					v-else
					v-for="(relation, r) in possibleRelations"
					:key="relation + r"
					class="py-3"
					:style="{
						borderBottom: `1px solid ${possibleRelations[possibleRelations.length - 1] === relation ? 'transparent' : '#fefefe20'}`,
					}">
					<v-btn
						:href="relationUrl(relation)"
						variant="plain"
						size="large"
						class="w-100 text-left d-flex align-center justify-start normal-spacing">
						<v-icon class="mr-3">mdi-link-variant</v-icon>
						{{ relation.name }}
					</v-btn>
				</div>
			</v-card-text>
		</v-card>
	</div>
</template>

<script>
	import axios from "axios"

	export default {
		name: "AdminShowRecord",
		props: {
			adminModule: { type: Object, default: () => ({}) },
			record: { type: Object, default: () => ({}) },
			possibleRelations: { type: Array, default: () => [] },
			basePath: { type: String, default: "" },
			user: { type: Object, default: () => ({}) },
		},
		computed: {
			editLink() {
				// e.g.: /admin/articles/123/edit
				return `/admin/${this.adminModule.slug}/${this.record.id}/edit`
			},
		},
		methods: {
			formatDate(dateString) {
				if (!dateString) return ""
				return new Date(dateString).toLocaleString()
			},
			canAction(actionName) {
				let userRoles = this.user.roles.map((role) => role.name)

				return this.adminModule.config.permissions[actionName].some((role) => userRoles.includes(role))
			},
			deleteRecord() {
				if (!confirm("Are you sure you want to delete this record?")) return

				axios
					.delete(`/admin/${this.adminModule.slug}/${this.record.id}`, {
						headers: {
							"X-CSRF-TOKEN": document.querySelector('meta[name="csrf-token"]').getAttribute("content"),
						},
					})
					.then(() => {
						window.location = `/admin/${this.adminModule.slug}`
					})
					.catch((err) => console.error(err))
			},
			relationUrl(relation) {
				// Ensure the basePath ends with the parent record's id.
				let base = this.basePath
				if (!base.endsWith(this.record.id.toString())) {
					base = `${base}/${this.record.id}`
				}
				// For a singular relation, include the related record id.
				if (relation.type === "model" && relation.id) {
					return `/${base}/${relation.name}/${relation.id}`
				}
				// For a collection relation, simply add the relation name.
				return `/${base}/${relation.name}`
			},
		},
	}
</script>
